import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Save, Settings as SettingsIcon } from 'lucide-react';

export default function Settings() {
  const api = useApi();
  const { can } = useAuth();
  const [settings, setSettings] = useState({
    welcome_image: '',
    welcome_text: '',
    contact_number: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const d = await api.get('/settings');
    if (d?.settings) setSettings(prev => ({ ...prev, ...d.settings }));
    setLoading(false);
  }

  async function save() {
    setSaving(true);
    const d = await api.post('/settings', { updates: settings });
    if (d?.success) toast.success('Settings save ho gayi!');
    else toast.error(d?.error || 'Error');
    setSaving(false);
  }

  if (loading) return (
    <div style={{ textAlign: 'center', padding: 60 }}>
      <span className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );

  return (
    <div className="page">
      <div className="page-header">
        <div className="section-title">⚙️ Bot Settings</div>
        <div className="section-sub">Bot ki general settings configure karein</div>
      </div>

      <div style={{ maxWidth: 600 }}>
        <div className="card">
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
            <SettingsIcon size={14} style={{ color: 'var(--emerald-400)' }} /> General Settings
          </div>

          <div className="field">
            <label className="label">Welcome Image URL</label>
            <input
              className="input"
              placeholder="https://example.com/image.jpg"
              value={settings.welcome_image || ''}
              onChange={e => setSettings(p => ({ ...p, welcome_image: e.target.value }))}
              disabled={!can('settings')}
            />
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
              Bot ke welcome message mein yeh image bhejta hai
            </div>
          </div>

          <div className="field">
            <label className="label">Welcome Text</label>
            <textarea
              className="textarea"
              placeholder="Khush Aamdeed! 🌹"
              value={settings.welcome_text || ''}
              onChange={e => setSettings(p => ({ ...p, welcome_text: e.target.value }))}
              disabled={!can('settings')}
              style={{ minHeight: 100, fontFamily: 'var(--font-urdu)', fontSize: 14, lineHeight: 2 }}
            />
          </div>

          <div className="field">
            <label className="label">Contact Number (WhatsApp)</label>
            <input
              className="input"
              placeholder="923130063295"
              value={settings.contact_number || ''}
              onChange={e => setSettings(p => ({ ...p, contact_number: e.target.value }))}
              disabled={!can('settings')}
            />
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
              Country code ke saath likhein, + ya spaces ke baghair (e.g. 923001234567)
            </div>
          </div>

          {can('settings') && (
            <div style={{ marginTop: 8 }}>
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : <Save size={14} />}
                {saving ? ' Saving...' : ' Save Karein'}
              </button>
            </div>
          )}
        </div>

        {settings.welcome_image && (
          <div className="card" style={{ marginTop: 16 }}>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>📷 Image Preview</div>
            <img
              src={settings.welcome_image}
              alt="Welcome"
              style={{ maxWidth: '100%', borderRadius: 8, border: '1px solid var(--border)' }}
              onError={e => { e.target.style.display = 'none'; }}
            />
          </div>
        )}
      </div>
    </div>
  );
}